import i18n from '@/libs/i18n'

export default [
  {
    path: '/support/docs',
    name: 'documentation',
    component: () => import('@/views/support/documentation/Documentation.vue'),
    meta: {
      pageTitle: i18n.t('Documentation'),
    },
  },
]
